import { mask } from 'maska'

// A `maska` ordena as variantes por comprimento (node_modules/maska/src/mask.js:18):
// 10 dígitos → (11) 3333-4444, 11 dígitos → (11) 99999-8888.
const PHONE_MASKS = JSON.stringify(['(##) #####-####', '(##) ####-####'])

/** Máscara progressiva para digitação — idempotente, aceita valor já mascarado. */
export const maskPhoneInput = (value: string | number | null | undefined): string =>
  value === null || value === undefined ? '' : mask(String(value), PHONE_MASKS)

/** Só os dígitos — formato em que o backend armazena o telefone. */
export const phoneDigits = (value: string | null | undefined): string =>
  (value ?? '').replace(/\D/g, '')
